module.exports = __webpack_public_path__ + "images/8ed2d9cc0d09daa2dbbf200582c1a773ef9f107b6ab15bb42c9fadb784a82bcf.svg";